<template>
  <div class="report-period-filter">
    <div class="report-period-filter__option report-period-filter__option--preset">
      <b-form-radio
        :checked="periodType"
        :name="radioName"
        value="list"
        @input="$emit('update:periodType', $event)"
      >Time period</b-form-radio>
      <b-select
        :value="timePeriod"
        :options="timeOptions"
        class="custom-select"
        :class="{ 'report-period-filter__control--hidden': periodType !== 'list' }"
        :disabled="periodType !== 'list'"
        @input="$emit('update:timePeriod', $event)"
      />
    </div>

    <span class="report-period-filter__separator">OR</span>

    <div class="report-period-filter__option report-period-filter__option--custom">
      <b-form-radio
        :checked="periodType"
        :name="radioName"
        value="custom"
        @input="$emit('update:periodType', $event)"
      >Custom date range</b-form-radio>
      <flat-pickr
        :value="selectedDates"
        :config="dateConfig"
        class="form-control"
        :class="{ 'report-period-filter__control--hidden': periodType !== 'custom' }"
        :disabled="periodType !== 'custom'"
        @input="$emit('update:selectedDates', $event)"
      />
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'ReportPeriodFilter',
  components: { flatPickr },
  props: {
    periodType: { type: String, required: true },
    timePeriod: { type: [Number, String], required: true },
    selectedDates: { type: [String, Array], default: null },
    timeOptions: { type: Array, required: true },
    dateConfig: { type: Object, required: true },
    radioName: { type: String, default: 'periodType' },
  },
};
</script>

<style lang="scss" scoped>
.report-period-filter {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 0 auto;
}

.report-period-filter__option {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}

.report-period-filter__option--preset .custom-select {
  width: 150px;
}

.report-period-filter__option--custom .form-control {
  width: 210px;
}

.report-period-filter__control--hidden {
  visibility: hidden;
}

.report-period-filter__separator,
.report-period-filter .custom-select,
.report-period-filter .form-control {
  height: 38px;
}

.report-period-filter__separator {
  display: inline-flex;
  align-items: center;
}

.report-period-filter__option ::v-deep .custom-control,
.report-period-filter__option ::v-deep .custom-control-label {
  display: flex;
  align-items: center;
  min-height: 38px;
  margin-bottom: 0;
  cursor: pointer;
}

.report-period-filter__option ::v-deep .custom-control-label::before,
.report-period-filter__option ::v-deep .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 767.98px) {
  .report-period-filter,
  .report-period-filter__option {
    width: 100%;
    flex-wrap: wrap;
  }

  .report-period-filter__option--preset .custom-select,
  .report-period-filter__option--custom .form-control {
    width: 100%;
  }
}
</style>
